<div
	[ngClass]="{
		'aspect-classic w-full lg:aspect-[9/4] lg:max-h-200 lg:min-h-146':
			size() === 'large',
		'h-[17rem] md:h-[20rem]': size() === 'small',
	}"
	class="relative flex"
	data-test-id="hero-item"
>
	<div
		class="w-full grow-0 rounded sm:order-2 sm:mb-0 max-lg:h-webkit-fill-available"
	>
		<article [attr.aria-labelledby]="'slide-heading-' + i()" class="h-full">
			@if (video()) {
				<div
					[ngClass]="{
						'aspect-classic w-full lg:aspect-[9/4] lg:max-h-200 lg:min-h-146':
							size() === 'large',
						'h-[17rem] md:h-[20rem] lg:h-[22rem]':
							size() === 'small',
					}"
					class="relative"
				>
					<vp-video
						[showControls]="false"
						[vimeoId]="video()?.vimeoId || 0"
						class="block scale-180 lg:scale-160 xl:scale-110"
					/>
				</div>
			} @else {
				@defer {
					<picture class="absolute top-0 size-full">
						<source
							[srcset]="
								(heroImage().src
									| imageQuery: { width: 800, height: 600 }) +
								' 640w, ' +
								(heroImage().src
									| imageQuery
										: {
												width: 1280,
												height: 960,
										  }) +
								' 1024w, ' +
								(heroImage().src
									| imageQuery
										: {
												width: 1800,
												height: 1000,
										  }) +
								' 1440w, ' +
								(heroImage().src
									| imageQuery
										: {
												width: 2400,
												height: 1000,
										  }) +
								' 1920w, ' +
								(heroImage().src
									| imageQuery
										: {
												width: 3600,
												height: 1000,
										  }) +
								' 2880w'
							"
							sizes="100vw"
							type="image/webp"
						/>
						<img
							[attr.alt]="heroImage().alt || null"
							[attr.fetchpriority]="i() === 0 ? 'high' : 'auto'"
							[attr.loading]="
								useEagerLoading() && i() === 0
									? 'eager'
									: 'lazy'
							"
							[attr.role]="
								!heroImage().alt ? 'presentation' : null
							"
							[height]="size() === 'large' ? 640 : 320"
							[ngClass]="{
								invisible: !isImageLoaded() && isSSRMode(),
								'bg-ui-25 object-none': !isCustomImage(),
							}"
							[src]="
								heroImage().src
									| imageQuery
										: {
												width: 1800,
												height:
													size() === 'large'
														? 1000
														: 300,
										  }
							"
							(error)="setImageFallback()"
							(load)="onImageLoad(i)"
							class="size-full object-cover"
							data-test-class="carousel__image"
							decoding="async"
							width="800"
						/>
					</picture>
				} @placeholder {
					<div
						class="absolute top-0 flex size-full items-center justify-center"
					>
						<svg-icon
							class="size-10 animate-spin text-dark-quaternary md:size-16"
							data-test-id="loader"
							src="assets/icons/icon-spinner.svg"
						/>
					</div>
				}
			}
			<div
				class="absolute left-0 top-0 size-full bg-gradient-to-b from-[#000000CC] to-transparent to-25% md:to-50%"
			></div>
			@if (heading()) {
				<div
					class="absolute bottom-0 left-0 size-full bg-gradient-to-t from-[#000000CC] to-transparent to-75% md:to-50%"
				></div>
			}
			<div
				class="absolute top-0 size-full px-3 md:px-8"
				id="hero-container"
			>
				<div class="section-inner flex h-full items-end">
					<div
						[class]="
							cn(
								contentMargin() === 'large' && 'mb-32 lg:mb-40',
								contentMargin() === 'small' &&
									'mb-18 md:mb-20 lg:mb-[104px]',
								contentMargin() === 'none' &&
									'mb-8 md:mb-12 lg:mb-16',
								'z-10 flex flex-col text-white'
							)
						"
					>
						@if (sticker()?.src) {
							<vp-image
								[image]="{
									src: sticker()!.src,
									altText: sticker()?.altText,
									width: 160,
									height: 160,
								}"
								[sources]="[
									{
										min: null,
										max: sizes.md,
										width: 128,
										height: 128,
									},
									{
										min: sizes.md,
										max: null,
										width: 160,
										height: 160,
									},
								]"
								class="mb-4 hidden size-16 md:block md:size-20"
							/>
						}
						<div
							[id]="'slide-heading-' + i()"
							class="text-shadow mb-0 font-display text-3xl children:lg:text-5xl children:lg:leading-tight"
						>
							@if (heading()) {
								<span class="block" data-test-id="heading">
									@if (headingType()) {
										<span
											[heading]="headingType()"
											class="mb-0 font-carousel"
											vc-heading
										>
											{{ heading() }}
										</span>
									} @else {
										<span class="font-carousel">
											{{ heading() }}
										</span>
									}
								</span>
							}
							<span
								class="block font-display font-carousel"
								data-test-id="subheading"
							>
								<ng-content select="vp-hero-item-sub-heading" />
							</span>
						</div>
						@if (link()?.url) {
							<vp-link
								[link]="link()"
								className="text-shadow mt-4 flex text-base font-semibold text-white no-underline outline-2 outline-offset-2 outline-white visited:text-white hover:text-white focus:rounded-md focus:outline md:text-lg"
							>
								{{ link().content }}
								<svg-icon
									class="ml-1 inline-block size-4 self-center fill-white"
									src="assets/icons/icon-chevron-right.svg"
								/>
							</vp-link>
						}
					</div>
				</div>
			</div>
		</article>
	</div>
</div>
